/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable eqeqeq */
import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import { Link, useLocation } from "react-router-dom";
import "../App.css";
// import NavDropdown from "react-bootstrap/NavDropdown";

const Header = () => {
  // const [active, setActive] = useState(false)
  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    // Function to handle scroll event
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const shouldStick = scrollTop > 50; // Change this condition as needed

      setIsSticky(shouldStick);
    };

    // Attach the scroll event listener
    window.addEventListener("scroll", handleScroll);

    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const location = useLocation();

  console.log(location.pathname, "active");

  const email = localStorage.getItem("email");
  const token = localStorage.getItem("token");

  const logout = () => {
    localStorage.clear();
    window.location.reload();
  };
  return (
    <>
      <Navbar
        bg="light"
        className={isSticky ? "navbar_sticky  px-5 navbar-custom" : "navbar-custom"}
        expand="lg"
      >
        <Container fluid>
          <Navbar.Brand href="#">
            <Link to="/">
              <img
                src="/img/logo.png"
                alt="DENTECTIVE"
                className="logo-image"
                // style={{ width: "200px", height: "130px" }}
              />
            </Link>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="ms-auto my-2 my-lg-0"
              style={{ maxHeight: "225px" }}
              navbarScroll
            >
              {/* <Link to="/" className={`pe-5 fs-6 my-auto ${location.pathname == "/" ? "active" : null}`}>Home</Link> */}
              <Link
                to="/about"
                className={`pe-5 fs-6 my-auto ${
                  location.pathname == "/about" ? "active" : null
                }`}
              >
                About
              </Link>
              {/* <Link
                to="/Mission"
                className={`pe-5 fs-6 my-auto ${
                  location.pathname == "/Mission" ? "active" : null
                }`}
              >
                Mission
              </Link> */}
              <Link
                to="/practitioner"
                className={`pe-5 fs-6 my-auto ${
                  location.pathname == "/practitioner" ? "active" : null
                }`}
              >
                Find Dentist
              </Link>
              <Link
                to="/contact"
                className={`pe-5 fs-6 my-auto ${
                  location.pathname == "/contact" ? "active" : null
                }`}
              >
                Contact
              </Link>
              {/* <Link
                to="/research"
                className={`pe-5 fs-6 my-auto ${
                  location.pathname == "/research" ? "active" : null
                }`}
              >
                Research
              </Link> */}
              {/* <a
                href="/Training"
                className={`pe-5 fs-6 my-auto ${
                  location.pathname == "/Training" ? "active" : null
                }`}
              >
                Certification
              </a> */}
              {/* <NavDropdown
                id="nav-dropdown"
                title="Resources"
                className="pe-5 fs-6 my-2"
              >
                <NavDropdown.Item
                  href="/research"
                  className={`pe-5 fs-6 my-auto ${
                    location.pathname == "/research" ? "active" : null
                  }`}
                >
                  Research
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="/Podcast"
                  className={`pe-5 fs-6 my-auto ${
                    location.pathname == "/Podcast" ? "active" : null
                  }`}
                >
                  Podcast
                </NavDropdown.Item>
                <NavDropdown.Item
                  href="/calendar"
                  className={`pe-5 fs-6 my-auto ${
                    location.pathname == "/calendar" ? "active" : null
                  }`}
                >
                  Calendar
                </NavDropdown.Item>
              </NavDropdown> */}

              {/* <Link
                to="/Podcast"
                className={`pe-5 fs-6 my-auto ${
                  location.pathname == "/Podcast" ? "active" : null
                }`}
              >
                Podcast
              </Link>
              <Link
                to="/Training"
                className={`pe-5 fs-6 my-auto ${
                  location.pathname == "/Training" ? "active" : null
                }`}
              >
                Training
              </Link> */}

              {/* <Link
                to="/RequestJoin"
                className={`btn btn-primary mx-3 mb-2  ${
                  location.pathname == "/RequestJoin" ? "active" : null
                }`}
              >
                Request to Join
              </Link> */}
            </Nav>
              {token ? (
                <>
                  <p className="me-3 btn-theme">{email}</p>
                  <button className="btn btn-primary" onClick={logout}>
                    Logout
                  </button>
                </>
              ) : (
                <>
                  <Link to="/register" className="me-3  btn-theme">SignUp</Link>
                  <Link to="/Login" className=" btn-theme mx-3 ">
                    Login
                  </Link>
                </>
              )}
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
